import template from './cardBase.html';
import controller from './cardBase.controller';
import './cardBase.scss';

let cardBaseComponent = {
  transclude: true,
  restrict: 'E',
  bindings: {
    card: '<',
    requestErrorMsg: '<',
    requestFoodBenefits: '&',
    checkModify: '&',
    resetCardState: '&',
    daysIsFocused: '&',
    isMobileApp: '<',
    withoutManager: '<',
    cardBaseId: '@'
  },
  template,
  controller,
};

export default cardBaseComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/userCardList/userCardRow/homeCard/cardBase/cardBase.component.js